import { Box, SxProps, styled } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

const TopBarBox = styled(Box)(({ theme }) => ({
  position: 'static',
  backgroundColor: theme.palette.primary[20],
  display: 'flex',
  flexBasis: '60px',
  height: '60px',
  minHeight: '60px',
  width: '100%',
  alignItems: 'center',
  padding: '0 40px',
}));

export const TopBar: FC<PropsWithChildren<{ sx?: SxProps }>> = ({ children, sx }) => {
  return <TopBarBox sx={sx}>{children}</TopBarBox>;
};
